/**
 * Helpers for the BDSA schema alias field `otherCaseIdentifiers`
 * (caseSource "NACC") and the clinical `NACCID` string field.
 */

export const NACC_CASE_SOURCE = 'NACC';

/**
 * Read NACC ID from case details (alias list preferred, then clinical NACCID).
 * @param {object|null|undefined} details
 * @returns {string}
 */
export function getNaccIdFromDetails(details) {
    if (!details || typeof details !== 'object') return '';
    const aliases = details.otherCaseIdentifiers;
    if (Array.isArray(aliases)) {
        const hit = aliases.find(
            (entry) => entry?.caseSource === NACC_CASE_SOURCE && entry?.caseID
        );
        if (hit?.caseID) return String(hit.caseID);
    }
    if (details.NACCID) return String(details.NACCID);
    if (details.clinicalData?.NACCID) return String(details.clinicalData.NACCID);
    return '';
}

/**
 * Return a copy of details with NACC ID set/cleared on both the alias list
 * and clinical NACCID for schema consumers.
 * @param {object|null|undefined} details
 * @param {string} naccId
 * @returns {object}
 */
export function setNaccIdInDetails(details, naccId) {
    const next = { ...(details || {}) };
    const trimmed = (naccId ?? '').trim();

    let aliases = Array.isArray(next.otherCaseIdentifiers)
        ? next.otherCaseIdentifiers.filter((entry) => entry?.caseSource !== NACC_CASE_SOURCE)
        : [];

    if (trimmed) {
        aliases = [...aliases, { caseID: trimmed, caseSource: NACC_CASE_SOURCE }];
        next.otherCaseIdentifiers = aliases;
        next.NACCID = trimmed;
        if (next.clinicalData && typeof next.clinicalData === 'object') {
            next.clinicalData = { ...next.clinicalData, NACCID: trimmed };
        }
    } else {
        if (aliases.length > 0) {
            next.otherCaseIdentifiers = aliases;
        } else {
            delete next.otherCaseIdentifiers;
        }
        delete next.NACCID;
        if (next.clinicalData && typeof next.clinicalData === 'object') {
            const clinicalData = { ...next.clinicalData };
            delete clinicalData.NACCID;
            next.clinicalData = clinicalData;
        }
    }

    return next;
}
